import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackerManagementExperience.trackerPositions'

const TrackerManagementTrackerPositionsSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackerManagementTrackerPositionsSlice
